import { createUseStyles } from 'react-jss';
import { spacing } from '@blink/components';

export const useDescriptionStyle = createUseStyles({
    description: {
        padding: `0 0 ${spacing['06']} ${spacing['06']}`,
    },
});
